export default function ReadNotice({ loading, error, stale, onRetry, label }: { loading: boolean; error?: unknown; stale?: boolean; onRetry: () => unknown; label: string }) {
  if (!loading && !error) return null;
  return <div role={error ? 'alert' : 'status'} className="rounded-xl bg-gray-50 p-3 text-xs text-gray-600">
    {loading ? `${label}读取中…` : `${label}读取失败${stale ? ' · 上次读取结果，本次更新失败' : ''}`}
    {!!error && <button className="ml-2 font-semibold text-indigo-600" onClick={() => { void onRetry(); }}>重试</button>}
  </div>;
}
